import { INotification } from "shared/components/organisms/AppNotification/@types";
import { IReactionMetadata } from "shared/components/organisms/AppNotification/@types/reactionTypes";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { useNotificationPlatformLogo } from "shared/components/organisms/AppNotification/hooks/useNotificationPlatformLogo";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

interface IReactionNotificationProps {
  notification: INotification<IReactionMetadata>;
}

export const ReactionNotification = ({
  notification,
}: IReactionNotificationProps) => {
  const { platformLogo } = useNotificationPlatformLogo();

  const notificationText =
    notification?.metadata?.count >= 2
      ? `e outros ${notification?.metadata?.count} reagiram ao seu comentário`
      : "reagiu ao seu comentário";

  const notificationIsFromLesson =
    !!notification?.metadata?.location?.lesson?.lesson_title;
  const notificationIsFromFeed =
    notification?.metadata?.reacted_on?.class === "App\\FeedPost";

  return (
    <Notification.Container wasReaded={false}>
      <Notification.IllustrationContainer>
        <Notification.UserPhoto
          photoSrc={notification?.metadata?.creator?.photo}
          username={notification?.metadata?.creator?.display_name}
          reaction={notification?.metadata?.reaction?.type}
        />
      </Notification.IllustrationContainer>

      <Notification.Title.Container>
        <Notification.Title.Highlight>
          {notification?.metadata?.creator?.display_name}
        </Notification.Title.Highlight>

        <Notification.Title.Text>{notificationText}</Notification.Title.Text>
      </Notification.Title.Container>

      <Notification.Content.Container>
        <Notification.Content.Text>
          {notification?.metadata?.reacted_on?.content}
        </Notification.Content.Text>
      </Notification.Content.Container>

      <Notification.Footer.Container>
        <Notification.Footer.Text>
          {formatTimeAgo(notification?.created_at)}
        </Notification.Footer.Text>

        <Notification.Footer.Dot />

        <Notification.Footer.Image
          label={
            notificationIsFromLesson
              ? "Aula"
              : notificationIsFromFeed
              ? "Feed"
              : "Comunidade"
          }
          src={
            notificationIsFromFeed
              ? platformLogo
              : notification?.metadata?.location?.lesson?.lesson_thumbnail ??
                notification?.metadata?.location?.group?.group_logo_horizontal
          }
          backgroundColor={
            notification?.metadata?.location?.group?.group_primary_color
          }
        />
      </Notification.Footer.Container>
    </Notification.Container>
  );
};
